import { NgModule } from '@angular/core';

import { RossSharedModule } from 'src/@ross/shared.module';

import { NavbarComponent } from './navbar.component';
import { NavbarVerticalStyle1Module } from './vertical/style-1/style-1.module';
import { ProfileImageDialogComponent } from './profile-image-dialog/profile-image-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
// import { MatDialog, MatDialogActions, MatDialogContent } from '@angular/material';

@NgModule({
    declarations: [
        NavbarComponent,
        ProfileImageDialogComponent
    ],
    imports     : [
        RossSharedModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule, 
        MatToolbarModule,
        // MatDialog,
        // MatDialogActions,
        // MatDialogContent,
        NavbarVerticalStyle1Module
    ],
    exports     : [
        NavbarComponent
    ], 
    entryComponents: [ProfileImageDialogComponent]
})
export class NavbarModule {
}
